import { Menu } from '@studiometa/ui';

/**
 * LocalizationMenu component
 */
export default class LocalizationMenu extends Menu {
  /**
   * Component Configuration
   */
  static config = {
    name: 'LocalizationMenu',
    refs: ['input[]', 'form'],
    components: {
      ...Menu.config.components,
    },
  };

  /**
   * onInputChange
   */
  onInputChange() {
    this.$refs.form.submit();
  }
}
